import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { formatErr } from "../lib/api";
import { LogIn, ArrowLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("مرحباً " + (u.name || ""));
      if (u.role === "SUPER_ADMIN") nav("/admin");
      else nav("/dashboard");
    } catch (er) { toast.error(formatErr(er)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen brand-soft grid place-items-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6" data-testid="login-brand">
          <div className="w-10 h-10 rounded-2xl brand-grad text-white grid place-items-center font-extrabold">خ</div>
          <span className="text-xl font-extrabold">خِفّة</span>
        </Link>
        <div className="bg-white rounded-3xl card-shadow border border-orange-100 p-6">
          <h1 className="text-2xl font-extrabold text-center">تسجيل الدخول</h1>
          <p className="text-sm text-gray-500 text-center mb-5">للمالك، الموظف، أو المشرف</p>
          <form onSubmit={submit} className="space-y-3">
            <label className="block">
              <span className="text-xs font-bold text-gray-600">البريد الإلكتروني</span>
              <input value={email} onChange={e => setEmail(e.target.value)} type="email" required data-testid="login-email"
                className="mt-1 w-full h-12 rounded-2xl bg-gray-50 border border-gray-200 px-4 focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none" />
            </label>
            <label className="block">
              <span className="text-xs font-bold text-gray-600">كلمة المرور</span>
              <input value={password} onChange={e => setPassword(e.target.value)} type="password" required data-testid="login-password"
                className="mt-1 w-full h-12 rounded-2xl bg-gray-50 border border-gray-200 px-4 focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none" />
            </label>
            <button disabled={busy} type="submit" className="w-full pill brand-grad text-white font-bold py-3.5 tap-target inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
              <LogIn size={18}/> {busy ? "جاري الدخول…" : "تسجيل الدخول"}
            </button>
            <button type="button" onClick={() => setShowForgot(true)} className="w-full text-sm text-orange-700 font-bold" data-testid="forgot-link">نسيت كلمة المرور؟</button>
          </form>
        </div>
        <div className="mt-4 text-center">
          <Link to="/demo" className="inline-flex items-center gap-1 text-sm text-gray-700 font-medium" data-testid="login-to-demo">
            <ArrowLeft size={14} className="rotate-180"/> جرّب النظام أولاً
          </Link>
        </div>
      </div>

      {showForgot && (
        <div className="fixed inset-0 z-40 bg-black/50 grid place-items-center p-5" onClick={() => setShowForgot(false)}>
          <div onClick={e => e.stopPropagation()} className="bg-white rounded-3xl p-6 max-w-sm w-full text-center rise-in">
            <div className="font-extrabold text-lg mb-2">نسيت كلمة المرور؟</div>
            <div className="text-sm text-gray-600 mb-4">تواصل مع مشرف المنصة لإعادة تعيين كلمة المرور.</div>
            <button onClick={() => setShowForgot(false)} className="w-full pill brand-grad text-white font-bold py-3 tap-target" data-testid="forgot-close">حسناً</button>
          </div>
        </div>
      )}
    </div>
  );
}
